import { Nullable } from '@/shared/types/app.types'

export interface DiagnosisConsultationModalConsultationDisplayState {
    receiverObservations: Nullable<string>
}
export const initialDiagnosisConsultationModalConsultationDisplayState =
    (): DiagnosisConsultationModalConsultationDisplayState => ({
        receiverObservations: null
    })
